export const USER_SURVEY_TITLE_CLASSNAME = 'typo-label-sm';

export const USER_SURVEY_ANSWER_MIN_LENGTH = 3;
